import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../helpers';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScopeTemplateModel } from '../models/scope-template.model';
import { ScopeTemplatesResponse } from '../interfaces/scope-template';
import { BaseService } from './base.service';

/**
 * Service for managing the scope of work descriptions.
 * --
 * Future changes to inclusions/exclusions may fall under this service
 */
@Injectable()
export class ScopeService extends BaseService<ScopeTemplateModel> {
	constructor(private http: HttpClient) {
		super(http, Constants.END_POINTS.scopeTemplates, ScopeTemplateModel);
	}

	/**
	 * Adds a new description of work for a company
	 * @param data
	 */
	public addScopeTemplate(data: { title: string; message: string; isActive: boolean; company: string; type: string }): Observable<ScopeTemplateModel> {
		return this.http.post<ScopeTemplateModel>(`${Constants.BASE_API_URL}/scope/scope-template`, data);
	}

	public getScopeTemplates(data: { company: string; type: string }): Observable<ScopeTemplateModel[]> {
		return this.http.get<ScopeTemplatesResponse>(`${Constants.BASE_API_URL}/scope/scope-templates`, { params: data as any }).pipe(map(res => res.templates ?? []));
	}

	public updateScopeTemplate(id: string, data: { title: string; message: string; isActive: boolean; type: string }): Observable<ScopeTemplateModel> {
		return this.http.put<ScopeTemplateModel>(`${Constants.BASE_API_URL}/scope/scope-template/${id}`, data);
	}

	public deleteScopeTemplate(id: string): Observable<void> {
		return this.http.delete<void>(`${Constants.BASE_API_URL}/scope/scope-template/${id}`);
	}
}
